<template>
  <div class="warning-stat">
    <el-dialog
      title="预警信号"
      :visible.sync="params.flag"
      v-dialogDrag
      :modal="false"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body="false"
      ref="yjxhRef"
      :before-close="beforeClose"
    >
      <div class="monitor">
        <div class="warning-list">
          <el-table :data="countyAlarm" height="100%" style="width: 100%" empty-text="暂无预警信号">
            <el-table-column prop="ddatetime" label="发布时间" width="160">
              <template #default="scoped">
                {{ $moment(scoped.row.ddatetime).format('YYYY-MM-DD HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column prop="aname" label="预警类型" width="100">
              <template #default="scoped">
                {{ scoped.row.aname.slice(0, -2) }}
              </template>
            </el-table-column>
            <el-table-column prop="aname" label="预警等级" width="90">
              <template #default="scoped">
                {{ scoped.row.aname.slice(-2) }}
              </template>
            </el-table-column>
            <el-table-column prop="county" label="区域"></el-table-column>
          </el-table>
        </div>
        <warning v-if="scope == 'GZ'"></warning>
        <div class="warn-box" v-else>
          <warning1></warning1>
        </div>
      </div>
      <div class="stat">
        <div class="month">
          <div class="title">当月发布预警信号</div>
          <div class="content">
            <div v-show="monthY.length > 0" id="month-chart"></div>
            <div v-show="monthY.length === 0" class="no-public">
              <span>当月无预警信号</span>
            </div>
          </div>
        </div>
        <div class="year">
          <div class="title">当年发布预警信号</div>
          <div class="content">
            <div v-show="pieData.length > 0" id="year-chart"></div>
            <div v-show="pieData.length === 0" class="no-public">
              <span>今年无预警信号</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Warning from './module/Warning.vue'
import Warning1 from './module/card/warn.vue'
import echarts from '@/config/echarts/index.js'
import { getMonthWarningOption, getYearWarningOption } from '@/config/echarts/option/warning.js'
import { mapState } from 'vuex'
import { apiData } from '../api/index'
export default {
  props: ['params'],
  data () {
    return {
      areas: ['禅城区', '南海区', '顺德区', '三水区', '高明区'],
      countyAlarm: [],
      monthX: [],
      monthY: [],
      pieData: [],
      tableData: [],
      scope: 'GZ'
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        flag && this.setZindex()
      },
      immediate: true
    }
  },
  created () {
    const { company } = this.$route.params
    const { unit } = JSON.parse(localStorage.getItem(company))
    this.scope = unit.scope
  },
  computed: {
    ...mapState('home', ['objsList'])
  },
  mounted () {
    this.searchData()
    this.getCountyAlarm()
  },
  methods: {
    monthWarning () {
      const monthChart = echarts.init(document.getElementById('month-chart'))
      const option = getMonthWarningOption()
      option.xAxis.data = this.monthX
      option.xAxis.data = option.xAxis.data.map(item => {
        if (item.length > 2) {
          item = item.slice(0, 2) + '\n' + item.slice(2)
        }
        return item
      })
      option.series[0].data = this.monthY
      monthChart.setOption(option)
      const yearChart = echarts.init(document.getElementById('year-chart'))
      const yearOption = getYearWarningOption()
      yearOption.series[0].data = this.pieData
      yearChart.setOption(yearOption)
      this.$nextTick(() => {
        monthChart.resize()
        yearChart.resize()
      })
      window.addEventListener('resize', () => {
        monthChart.resize()
        yearChart.resize()
      })
    },

    /**
     * 正在生效的区县预警信号
     */
    async getCountyAlarm () {
      const result = await apiData.countyAlarm()
      const arr = new Set([])
      this.objsList.forEach(item => {
        arr.add(item.county)
      })
      this.areas = [...arr]
      this.areas.forEach(item => {
        const arr = result[item] ? result[item] : []
        this.countyAlarm.push(...arr)
      })
    },

    async searchData () {
      const y = new Date().getFullYear()
      const m = (new Date().getMonth() + 1 + '').padStart(2, '0')
      const d = (new Date().getDate() + '').padStart(2, '0')
      const monthParams = {
        stime: y + '-' + m + '-' + '01 00:00',
        etime: y + '-' + m + '-' + d + ' 00:00',
        page: 1,
        pagesize: 2000,
        signame: [],
        siglevel: []
      }
      const yearParams = {
        stime: y + '-01-01 00:00',
        etime: y + '-' + m + '-' + d + ' 00:00',
        page: 1,
        pagesize: 2000,
        signame: [],
        siglevel: []
      }
      if (this.scope === 'GD') {
        let county = []
        const arr = new Set()
        console.log(this.objsList)
        this.objsList.forEach(item => {
          arr.add(item.county.slice(0, 2))
        })
        county = [...arr]
        monthParams.county = county
        yearParams.county = county
      } else {
        monthParams.city = '佛山'
        yearParams.city = '佛山'
      }

      const monthResult = await apiData.queryAlarmForCounty(monthParams)
      const yearResult = await apiData.queryAlarmForCounty(yearParams)
      this.monthData = monthResult.data.datas
      this.yearData = yearResult.data.datas

      // 获取X轴和Y轴得数据
      const monthOptionData = this.getXY(this.monthData)
      this.monthX = monthOptionData.x
      this.monthY = monthOptionData.y

      const yearOptionData = this.getXY(this.yearData)
      yearOptionData.x.forEach((item, index) => {
        this.pieData.push({ value: yearOptionData.y[index], name: item })
      })

      this.$nextTick(() => {
        this.monthWarning()
      })
    },

    // 获取X和Y轴的数据
    getXY (data) {
      const alarnValue = {}
      const alarnType = []
      data.forEach(item => {
        const flag = alarnType.some(name => item.aname.includes(name))
        const name = item.aname.slice(0, -2)
        if (!flag) {
          alarnType.push(name)
          alarnValue[name] = 0
        }
        alarnValue[name]++
      })
      return { x: Object.keys(alarnValue), y: Object.values(alarnValue) }
    },

    beforeClose () {
      this.params.flag && this.$parent.toggleProductView('WarningStat')
    },

    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.yjxhRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        console.log(el)
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    }
  },
  components: { Warning, Warning1 }
}
</script>
<style lang="less" scoped>
.warning-stat {
  pointer-events: none;
  .monitor {
    display: flex;
    height: 35vh;
    .warning-list {
      width: 37.81rem;
      .el-table {
        background: transparent;
        text-align: center;

        /deep/ tr {
          background: transparent;
          th {
            text-align: center;
            border: 0;
            font-size: 0.88rem;
            font-weight: 600;
            color: #fff;
            background: #0c4170;
          }
          td {
            text-align: center;
            font-size: 0.88rem;
            font-weight: 400;
            color: #fff;
            border-bottom: 1px solid #316ea3;
          }
          .print {
            width: 1.13rem;
            height: 1.13rem;
            background: url('../assets/images/打印.png') no-repeat;
            border: 0;
            cursor: pointer;
            background-size: 1.13rem 1.13rem;
          }
          .image {
            margin: 0.52vw;
            width: 1.09vw;
            cursor: pointer;
          }
        }
        /deep/ tr:hover td {
          background: #0c4170 !important;
        }

        .new {
          margin-left: 0.52vw;
          background-color: #f56c6c;
          border-radius: 0.32vw;
          color: #fff;
          display: inline-block;
          font-size: 0.43vw;
          height: 0.94vw;
          line-height: 0.94vw;
          padding: 0.1vw 0.31vw;
          text-align: center;
          white-space: nowrap;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #273458;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #1b2230;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 5px;
          background: #0c4170;
        }
        /deep/.el-table__fixed-right-patch {
          background: #1b3b80;
          border: 0;
        }
      }
      .el-table::before {
        background: transparent;
      }
    }
    .warning {
      margin-left: 5.81rem;
    }
  }
  .stat {
    margin-top: 1.5rem;
    flex: 1;
    display: flex;
    .title {
      font-size: 1rem;
      font-weight: 600;
      color: #fff;
    }
    .month {
      width: 37.81rem;
      display: flex;
      flex-direction: column;
      .content {
        flex: 1;
        position: relative;
        #month-chart {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
        .no-public {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      }
    }
    .year {
      margin-left: 5.81rem;
      flex: 1;
      display: flex;
      flex-direction: column;
      .content {
        flex: 1;
        position: relative;
        .no-public {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
        #year-chart {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
      }
    }
  }
  /deep/.el-dialog__wrapper {
    .el-dialog {
      pointer-events: auto;
      width: 85.81rem;
      margin-top: 8vh !important;
      height: 84vh;
    }
  }
}

.warn-box {
  position: relative;
  flex: 1;
  .warning {
    margin-left: 3.81rem !important;
    padding: 1vh 0;
  }
}
</style>
